import React from "react";
import { Link, withRouter } from "react-router-dom";

class SoldierList extends React.Component {
  constructor(props) {
    super(props);
    this.changeCur = props.changeCur;
    this.measur = props.measur;
  }

  componentDidMount() {
    this.update.apply(this.measur);
  }

  checkHealth(x) {
    let { health } = x;
    let result = true;
    result = result && health.tempeture < 37.0;
    result = result && health.alcohol < 0.03;
    result = result && health.pulse >= 60 && health.pulse <= 100;
    result = result && health.garments;
    return result;
  }

  async resetSoldier() {
    if (this.state.soldiers.length === 0) {
      this.alert.show("삭제할 인원이 없습니다.");
      return;
    }
    let arr = this.state.soldiers.filter((x) => {
      return !x.checked;
    });
    if (arr.length === this.state.soldiers.length) {
      this.alert.show("삭제할 인원을 선택해주세요.");
      return;
    }

    let del = this.state.soldiers.filter((x) => {
      return x.checked;
    });

    await this.ds.deleteTrain(del.map((x) => x.dt_number));

    this.setState({
      soldiers: arr,
      allCheck: false,
      curSolider: this.dummy,
    });
  }

  resetRecord() {
    this.setState({
      soldiers: this.state.soldiers.map((x) => {
        x.count = "-";
        x.uncount = "-";
        return x;
      }),
    });
  }

  handelCheck(i) {
    let arr = [...this.state.soldiers];
    arr[i].checked = !arr[i].checked;
    let all = true;
    arr.forEach(({ checked }) => {
      all = all && checked;
    });

    this.setState({
      soldiers: arr,
      allCheck: all,
    });
  }

  checkAll() {
    let arr = this.state.soldiers.map((x) => {
      x.checked = !this.state.allCheck;
      return x;
    });
    this.setState({
      soldiers: arr,
      allCheck: !this.state.allCheck,
    });
  }

  update() {
    this.ds
      .getTrainPeople()
      .then((x) => x.json())
      .then((x) => {
        return x.map((y) => {
          y.count = "-";
          y.uncount = "-";
          y.checked = false;
          return y;
        });
      })
      .then((x) => {
        this.setState({ soldiers: x });
      })
      .catch((err) => {
        if (err.message === "Untokenized") alert("로그인 되지 않았습니다.");
      });
  }

  render() {
    return (
      <div className="info02">
        <div className="con_btn left">
          <div className="btn_refresh" onClick={this.update.bind(this.measur)}>
            <Link to="#">새로고침</Link>
          </div>
        </div>
        <h4>측정자 정보</h4>
        <div className="con_btn">
          <div
            className="btn_reset"
            onClick={this.resetRecord.bind(this.measur)}
          >
            <Link to="#">기록 초기화</Link>
          </div>
          <div
            className="btn_del"
            onClick={this.resetSoldier.bind(this.measur)}
          >
            <Link to="#">인원 삭제</Link>
          </div>
        </div>
        <div className="tb_w">
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    checked={this.props.allCheck}
                    onChange={this.checkAll.bind(this.measur)}
                  />
                </th>
                <th>구분</th>
                <th>이름</th>
                <th>군번</th>
                <th colSpan="2">횟수(정/오)</th>
                <th>위치</th>
                <th>상태</th>
              </tr>
            </thead>
            <tbody>
              {this.props.soldiers.length === 0 ? (
                <tr>
                  <td colSpan="8">측정자가 없습니다.</td>
                </tr>
              ) : (
                this.props.soldiers.map((x, i) => (
                  <tr
                    key={i}
                    onClick={() => this.changeCur.apply(this.measur, [x])}
                  >
                    <td>
                      <input
                        type="checkbox"
                        name={i}
                        checked={x.checked}
                        onChange={() =>
                          this.handelCheck.apply(this.measur, [i])
                        }
                      />
                    </td>
                    <td>{i}</td>
                    <td>{x.name}</td>
                    <td>{x.dt_number}</td>
                    <td>{x.count}</td>
                    <td>{x.uncount}</td>
                    <td>{x.loc}</td>
                    <td>{this.checkHealth(x) ? "○" : "X"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withRouter(SoldierList);
